import { CoreBox, CoreTypography } from '@youscience/core';

import useSchoolSearchFiltersStore, { INITIAL_SCHOOL_SORT } from '@store/SchoolSearchFiltersStore';

import { useStateSpotlight } from '@hooks/useStateSpotlight';

import { ROUTES } from '@constants/ROUTES';
import { DESKTOP_PER_PAGE_OPTIONS } from '@constants';
import {
  STATE_PUBLIC_COLLEGE_FILTER,
  STATE_SPOTLIGHT_SCHOOL_SORT,
  getExploreStatePublicCollegesLabel,
} from '@constants/stateSpotlight';

import { UsheIcon } from '@components/UsheIcon';

import ChevronRight from '@images/chevron-right.svg?react';

import { sxStyles, StyledBannerWrap } from './StateSpotlightBanner.styles';

export const StateSpotlightBanner = () => {
  const { spotlight, markDefaultsApplied } = useStateSpotlight();
  const resetSchoolFilters = useSchoolSearchFiltersStore((state) => state.resetSearchFilters);
  const setSortByValues = useSchoolSearchFiltersStore((state) => state.setSortByValues);

  if (!spotlight) {
    return null;
  }

  const handleClick = () => {
    resetSchoolFilters({ limit: DESKTOP_PER_PAGE_OPTIONS[0], [STATE_PUBLIC_COLLEGE_FILTER]: [spotlight.stateCode] });

    if (useSchoolSearchFiltersStore.getState().sortByValues.sort === INITIAL_SCHOOL_SORT.sort) {
      setSortByValues(STATE_SPOTLIGHT_SCHOOL_SORT);
    }

    markDefaultsApplied('schools');
  };

  return (
    <StyledBannerWrap data-testid="stateSpotlightBanner" to={ROUTES.SCHOOLS} onClick={handleClick}>
      <CoreBox sx={sxStyles.titleWrap}>
        <UsheIcon size={24} />

        <CoreTypography variant="subtitle1" component="h2">
          {getExploreStatePublicCollegesLabel(spotlight.stateName, spotlight.publicCollegeIds.length)}
        </CoreTypography>
      </CoreBox>

      <CoreTypography component="span" variant="body2" sx={sxStyles.action}>
        See colleges
        <ChevronRight />
      </CoreTypography>
    </StyledBannerWrap>
  );
};
